import { DashboardContent } from './DashboardContent'
import './styles.modules.scss'

export default DashboardContent
